module.exports = __webpack_public_path__ + "img/Mono Logo(en)_Light.a97dc750.svg";